import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges, ViewChild } from "@angular/core";
import * as XLSX from "xlsx";
import { AppMainComponent } from "src/app/app.main.component";
import { FinancePrintUtilityComponent } from "../finance-print-utility/finance-print-utility.component";
@Component({
    selector: "app-export-utility",
    templateUrl: "./export-utility.component.html",
})
export class ExportUtilityComponent implements OnChanges {
    @Input({ required: true }) display: boolean;
    @Input({ required: true }) isExpanded: boolean;
    @Input({ required: true }) cols: any[];
    @Input({ required: true }) profitReport: any[];
    @Input({ required: true }) selectedWindow: string;
    @Input({ required: true }) dateTo: string;
    @Input({ required: true }) dateFrom: string;
    @Input({ required: true }) selectedDateFilter: string;
    @Output() onClose = new EventEmitter();
    reportType: string;
    @ViewChild(FinancePrintUtilityComponent) plBalanceSheetPrintPdf: FinancePrintUtilityComponent;
    constructor(public app: AppMainComponent) {}
    ngOnChanges(changes: SimpleChanges): void {
        if (changes?.selectedWindow?.currentValue) {
            this.reportType = this.selectedWindow == "balance" ? "Balance_Sheet_Report" : this.selectedWindow == 'pLStatement' ? "P_&_L_Report" : "Cashflow Statement";
        }
    }
    export(type: "open" | "pdf" | "csv" | "xlsx") {
        if (type === "pdf") {
            this.exportPdf();
        } else if (type === "csv") {
            this.exportCsv();
        } else if (type === "xlsx") {
            this.exportXlsx();
        } else if (type === "open") {
            this.showPdf();
        }
    }
    exportCsv() {
        const data = this.flattenData(this.profitReport);
        const csvContent = this.convertToCsv(data);
        const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
        const link = document.createElement("a");
        link.href = URL.createObjectURL(blob);
        link.download = `${this.reportType}.csv`;
        link.click();
        URL.revokeObjectURL(link.href);
    }
    convertToCsv(data: any[]): string {
        const headers = this.cols.map((col) => col.header.split(",")[0]);
        const rows = data.map((item) =>
        this.cols.map((col) => {
            const value = item[col.field];
            return typeof value === "number" ? value.toFixed(2) : value ?? "";
        })
    );
        const csvRows = [headers, ...rows];
        return csvRows.map((row) => row.join(",")).join("\n");
    }
    exportXlsx() {
        const data = this.flattenData(this.profitReport);
        const formattedData = data.map((item) => {
            const formattedItem: any = {};
            this.cols.forEach((col) => {
                let header = col.header;
                while (formattedItem.hasOwnProperty(header)) {
                    header += " ";
                }
                let value = item[col.field] ?? "";
                if(typeof value === "number"){
                     value = value.toFixed(2);
                }
                formattedItem[header] = value;
            });
            return formattedItem;
        });

        const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(formattedData);
        const colWidths = this.cols.map((col) => ({ width: 20 }));
        worksheet["!cols"] = colWidths;

        const headerRange = XLSX.utils.decode_range(worksheet["!ref"]);
        for (let col = headerRange.s.c; col <= headerRange.e.c; col++) {
            const cellAddress = XLSX.utils.encode_cell({ r: 0, c: col });
            if (!worksheet[cellAddress]) continue;
            worksheet[cellAddress].s = { font: { bold: true } };
        }
        const workbook: XLSX.WorkBook = { Sheets: { [this.reportType]: worksheet }, SheetNames: [this.reportType] };
        const excelBuffer: any = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
        this.saveAsExcelFile(excelBuffer, this.reportType);
    }

    flattenData(data: any[]): any[] {
        const flattenedData: any[] = [];
        data?.forEach((item) => {
            const mappedItem: any = {};
            this.cols.forEach((col) => {
                mappedItem[col.field] = item.data[col.field] ?? "";
            });
            flattenedData.push(mappedItem);
            if (item.children && item.children.length > 0 && this.isExpanded) {
                this.addChildrenToFlattenedData(item.children, flattenedData);
            }
        });
        return flattenedData;
    }

    addChildrenToFlattenedData(children: any[], flattenedData: any[]) {
        children.forEach((child) => {
            const mappedChild: any = {};
            this.cols.forEach((col) => {
                mappedChild[col.field] = col.field.includes("percentage") ? `${child.data[col.field]}  %` : (child.data[col.field] ?? 0);
            });
            flattenedData.push(mappedChild);
            if (child.children && child.children.length > 0 && this.isExpanded) {
                this.addChildrenToFlattenedData(child.children, flattenedData);
            }
        });
    }

    saveAsExcelFile(buffer: any, fileName: string): void {
        const data: Blob = new Blob([buffer], { type: "application/octet-stream" });
        const link = document.createElement("a");
        link.href = URL.createObjectURL(data);
        link.download = `${fileName}.xlsx`;
        link.click();
        URL.revokeObjectURL(link.href);
    }
    onDialogHide() {
        this.onClose.emit({ close: true });
    }
    exportPdf() {
        this.plBalanceSheetPrintPdf.saveDetails();
    }
    showPdf() {
        this.plBalanceSheetPrintPdf.printDetails();
    }
}